var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullnameLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5419 23.2429C11.8924 23.2429 7.06787 24.0971 7.06787 27.5179C7.06787 30.9388 11.8618 31.8236 17.5419 31.8236C23.1914 31.8236 28.0145 30.968 28.0145 27.5485C28.0145 24.1291 23.222 23.2429 17.5419 23.2429Z",
    stroke: "#6E7079",
    strokeWidth: 2.19107,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5419 18.3635C21.2493 18.3635 24.2542 15.3572 24.2542 11.6498C24.2542 7.94239 21.2493 4.9375 17.5419 4.9375C13.8344 4.9375 10.8282 7.94239 10.8282 11.6498C10.8156 15.3447 13.8011 18.351 17.4946 18.3635H17.5419Z",
    stroke: "#6E7079",
    strokeWidth: 2.08673,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullnameLogo);
export default __webpack_public_path__ + "static/media/fullname_logo.7b31b1860bd8b4a69fcc21a9a5d66ef3.svg";
export { ForwardRef as ReactComponent };